import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

export function InsuranceOcrResultsFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.patientUploadId"
        label="Patient Upload ID"
        helperText="UUID of the patient upload containing the insurance card"
      />
    </Stack>
  );
}
